import { useQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from '@/query/queryKeys';
import { useUserStore } from '@/store/userStore';
import { userService } from '../../services/userService';

export const useGetProfile = () => {
  const accessToken = useUserStore(state => state.accessToken);
  return useQuery({
    queryKey: [QUERY_KEYS.user.profile],
    enabled: !!accessToken,
    queryFn: () =>
      userService.profile().then(response => {
        const { status, data } = response;
        if (status === 200) {
          return data;
        }
        return null;
      }),
  });
};
